// TODO: Check if App.scss needed
import './custom.scss'
import React from 'react'
import { ProtectedLayout } from './lib/auth-helper';
import { Route, Routes } from 'react-router-dom'
import { AlertContainer } from './lib/alert';
import LoginPage from './pages/LoginPage'
import QuizPage from './pages/QuizPage'
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerificationPage from './pages/VerificationPage';
import ResultsPage from './pages/ResultsPage';
import NotFoundPage from './pages/NotFoundPage'
import ReactGA4 from 'react-ga4';
import TopNavBar from './components/TopNavBar';


const measurementId = 'G-XDCWSCGSSH';
ReactGA4.initialize(measurementId);

function App() {
  return (
    <AlertContainer>
      <TopNavBar />
      <Routes>
        <Route path="/root" element={<LoginPage login />} />
        <Route path="*" element={<NotFoundPage />} />

        {/* Not logged users */}
        <Route element={<ProtectedLayout noUser redirectTo="/" />}>
          <Route path="/login" element={<LoginPage login />} />
          <Route path="/signup" element={<LoginPage signup />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />
          <Route path="/verification" element={<VerificationPage />} />
          <Route path="/resetPassword" element={<ResetPassword />} />
        </Route>
        {/* Logged, registered users */}
        <Route element={<ProtectedLayout needsUser redirectTo="/login" />}>
          <Route path="/" element={<QuizPage />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/verification" element={<VerificationPage />} />

        </Route>
      </Routes>
    </AlertContainer>
  );
}

export default App;
